export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/fc6526beeb866847.png"